var moment = require('moment');

var React = require('react');

var ChartLine = require('../Chart/Line');

var Line = React.createClass({
    propTypes: {
        limits: React.PropTypes.object,
        usage: React.PropTypes.array,
        width: React.PropTypes.number.isRequired
    },

    getDefaultProps: function () {
        return {
            limits: [],
            usage: []
        }
    },

    getLimits: function (limits) {
        // Only print download limits atm.
        var baselines = [];

        limits.combined.forEach((limit, index) => {
            baselines.push({ name: index > 0 ? 'Additional Usage' : 'Usage Limit', value: limit })
        })

        limits.down_peak.forEach(function (limit, index) {
            baselines.push({ name: index > 0 ? 'Additional Download' : 'Download Limit', value: limit });
        });

        limits.up_peak.forEach(function (limit, index) {
            baselines.push({ name: index > 0 ? 'Additional Upload' : 'Upload Limit', value: limit });
        });

        return baselines;
    },

    getSeries: function (usage, showCombined) {
        var now = new Date();

        var processed = usage.map(function (dataPoint) {
            var usageIn = dataPoint.totals.in_bytes_peak + dataPoint.totals.in_bytes_offpeak,
                usageOut = dataPoint.totals.out_bytes_peak + dataPoint.totals.out_bytes_offpeak;
            if (isNaN(usageIn)) {
                usageIn = 0;
            }
            if (isNaN(usageOut)) {
                usageOut = 0;
            }

            return {
                date: moment(dataPoint.start).toDate(),
                usageIn: usageIn,
                usageOut: usageOut
            }
        }).filter(function (dataPoint) {
            return dataPoint.date < now;
        });

        var data = [];

      data.push({
            name: 'Downloads',
            values: processed.map(function (d) {
                return { date: d.date, value: d.usageIn };
            })
        });
        data.push({
            name: 'Uploads',
            values: processed.map(function (d) {
                return { date: d.date, value: d.usageOut };
            })
        });
      if (showCombined) {
        data.push({
          name: 'Combined',
          values: processed.map(d => ({ date: d.date, value: d.usageIn + d.usageOut }))
        })
      }

      return data;
    },

    render: function () {
        var series = this.getSeries(this.props.usage, this.props.limits.combined.length);
        var limits = this.getLimits(this.props.limits);

        return <ChartLine
            series={series}
            baselines={limits}
            width={this.props.width}
            height={this.props.width * 0.6} />;
    }
})
module.exports = Line;



// WEBPACK FOOTER //
// ./app/components/Bandwidth/Line.js